import React, { useState, useEffect } from 'react';
import './DashboardAdmin.css';

const DashboardAdmin = ({ token }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [dashboardData, setDashboardData] = useState({
    ventasPorProvincia: { mes: [], semana: [], hoy: [] },
    topJefes: { mes: [], semana: [], hoy: [] },
    topSupervisores: { mes: [], semana: [], hoy: [] }
  });

  useEffect(() => {
    fetchDashboardData();
  }, [token]);

  const fetchDashboardData = async () => {
    setLoading(true);
    setError('');
    try {
      // Usar datos mock por ahora
      const mockData = {
        ventasPorProvincia: {
          mes: [
            { provincia: 'Lima', total: 15000 },
            { provincia: 'Arequipa', total: 8500 },
            { provincia: 'Trujillo', total: 7200 },
            { provincia: 'Piura', total: 6800 },
            { provincia: 'Cusco', total: 5200 }
          ],
          semana: [
            { provincia: 'Lima', total: 3800 },
            { provincia: 'Arequipa', total: 2100 },
            { provincia: 'Trujillo', total: 1800 },
            { provincia: 'Piura', total: 1700 },
            { provincia: 'Cusco', total: 1300 }
          ],
          hoy: [
            { provincia: 'Lima', total: 850 },
            { provincia: 'Arequipa', total: 420 },
            { provincia: 'Trujillo', total: 380 },
            { provincia: 'Piura', total: 350 },
            { provincia: 'Cusco', total: 280 }
          ]
        },
        topJefes: {
          mes: [
            { nombre: 'Carlos García', total: 12500 },
            { nombre: 'Ana Martínez', total: 11800 },
            { nombre: 'Roberto López', total: 10200 },
            { nombre: 'María Torres', total: 9800 },
            { nombre: 'Luis Sánchez', total: 9200 }
          ],
          semana: [
            { nombre: 'Carlos García', total: 3200 },
            { nombre: 'Ana Martínez', total: 2900 },
            { nombre: 'Roberto López', total: 2600 },
            { nombre: 'María Torres', total: 2400 },
            { nombre: 'Luis Sánchez', total: 2200 }
          ],
          hoy: [
            { nombre: 'Carlos García', total: 750 },
            { nombre: 'Ana Martínez', total: 680 },
            { nombre: 'Roberto López', total: 620 },
            { nombre: 'María Torres', total: 580 },
            { nombre: 'Luis Sánchez', total: 520 }
          ]
        },
        topSupervisores: {
          mes: [
            { nombre: 'Juan Pérez', total: 8900 },
            { nombre: 'Carmen Vargas', total: 8200 },
            { nombre: 'Miguel Soto', total: 7800 },
            { nombre: 'Lucía Torres', total: 7200 },
            { nombre: 'Pedro Gómez', total: 6800 }
          ],
          semana: [
            { nombre: 'Juan Pérez', total: 2200 },
            { nombre: 'Carmen Vargas', total: 2000 },
            { nombre: 'Miguel Soto', total: 1900 },
            { nombre: 'Lucía Torres', total: 1800 },
            { nombre: 'Pedro Gómez', total: 1700 }
          ],
          hoy: [
            { nombre: 'Juan Pérez', total: 520 },
            { nombre: 'Carmen Vargas', total: 480 },
            { nombre: 'Miguel Soto', total: 450 },
            { nombre: 'Lucía Torres', total: 420 },
            { nombre: 'Pedro Gómez', total: 390 }
          ]
        }
      };
      setDashboardData(mockData);
    } catch (err) {
      console.error('Error al cargar datos del dashboard:', err);
      setError('Error al cargar los datos del dashboard');
    } finally {
      setLoading(false);
    }
  };

  const graficas = [
    {
      titulo: 'Ventas por provincia (Mes actual)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por provincia en el mes actual',
      data: dashboardData.ventasPorProvincia.mes,
      type: 'provincia',
      icon: '📊'
    },
    {
      titulo: 'Top 5 Jefes (Mes actual)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por los 5 Jefes Top en el mes actual',
      data: dashboardData.topJefes.mes,
      type: 'jefe',
      icon: '👔'
    },
    {
      titulo: 'Top 5 Supervisores (Mes actual)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por los 5 supervisores Top en el mes actual',
      data: dashboardData.topSupervisores.mes,
      type: 'supervisor',
      icon: '👨‍💼'
    },
    {
      titulo: 'Ventas por provincia (Semana actual)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por provincia en la semana actual',
      data: dashboardData.ventasPorProvincia.semana,
      type: 'provincia',
      icon: '📈'
    },
    {
      titulo: 'Top 5 Jefes (Semana actual)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por los 5 Jefes Top en la semana actual',
      data: dashboardData.topJefes.semana,
      type: 'jefe',
      icon: '🏆'
    },
    {
      titulo: 'Top 5 Supervisores (Semana actual)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por los 5 supervisores Top en la semana actual',
      data: dashboardData.topSupervisores.semana,
      type: 'supervisor',
      icon: '📋'
    },
    {
      titulo: 'Ventas por provincia (Hoy)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por provincia Hoy',
      data: dashboardData.ventasPorProvincia.hoy,
      type: 'provincia',
      icon: '📅'
    },
    {
      titulo: 'Top 5 Jefes (Hoy)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por los 5 Jefes Top Hoy',
      data: dashboardData.topJefes.hoy,
      type: 'jefe',
      icon: '⭐'
    },
    {
      titulo: 'Top 5 Supervisores (Hoy)',
      descripcion: 'En esta gráfica se visualizará los totales de ventas por los 5 supervisor Top Hoy',
      data: dashboardData.topSupervisores.hoy,
      type: 'supervisor',
      icon: '🎯'
    },
  ];

  if (loading) {
    return (
      <div className="dashboard-pro-container">
        <div style={{textAlign: 'center', padding: '50px', color: 'white'}}>
          <h3>🔄 Cargando dashboard...</h3>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-pro-container">
      {error && (
        <div className="error-message" style={{margin: '20px', textAlign: 'center'}}>
          {error}
        </div>
      )}
      
      <div className="dashboard-pro-grid">
        {graficas.map((graf, idx) => (
          <div
            className="dashboard-pro-card"
            key={idx}
          >
            <div className="dashboard-pro-card-title">
              <span style={{marginRight: '8px'}}>{graf.icon}</span>
              {graf.titulo}
            </div>
            <div className="dashboard-pro-card-desc">{graf.descripcion}</div>
            <div className="dashboard-pro-chart-container">
              {graf.data && graf.data.length > 0 ? (
                <div className="chart-data">
                  <table>
                    <thead>
                      <tr>
                        <th>{graf.type === 'provincia' ? 'Provincia' : 'Nombre'}</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {graf.data.slice(0, 5).map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{item.provincia || item.nombre}</strong>
                          </td>
                          <td>
                            <span style={{
                              color: '#667eea',
                              fontWeight: 'bold',
                              fontSize: '13px'
                            }}>
                              S/ {item.total.toLocaleString()}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="dashboard-pro-chart-placeholder">
                  <span>📊 Sin datos disponibles</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardAdmin; 